import React, { Component } from "react";

import axios from "../../axios-instance";
import NewLoader from "../NewLoader/NewLoader";

import { getHeaders } from "../../helpers/getHeaders";

import Icon from "../UI/Icon/Icon";

export class DashboardInfo extends Component {
  state = {
    totalTicketsSold: "",
    uniqueBuyers: "",
    maleBuyers: "",
    femaleBuyers: "",
    unindefiedCustomers: "",
    averageAge: "",
    loading: true,
  };

  getData = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      this.setState({ loading: true });
      const { data } = await axios.get("/Events/GeneralStats", {
        headers: getHeaders(user.token),
      });
      this.setState({ loading: false, ...data });
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.getData();
  }

  render() {
    const {
      averageAge,
      femaleBuyers,
      loading,
      maleBuyers,
      totalTicketsSold,
      unindefiedCustomers,
      uniqueBuyers,
    } = this.state;

    if (loading) {
      return (
        <div className="dashboard__info">
          <NewLoader />
        </div>
      );
    }

    return (
      <div className="dashboard__info">
        <div className="dashboard__info-row">
          <div className="dashboard__info-item">
            <div className="dashboard__info-item-hero">
              <h6>Total Tickets Sold</h6>
              <p>{totalTicketsSold}</p>
            </div>
            <div className="dashboard__info-item-icon">
              <Icon name="total-tickets-sold" />
            </div>
          </div>
          <div className="dashboard__info-item">
            <div className="dashboard__info-item-hero">
              <h6>Unique Buyers</h6>
              <p>{uniqueBuyers}</p>
            </div>
            <div className="dashboard__info-item-icon">
              <Icon name="unique-buyers" />
            </div>
          </div>
          <div className="dashboard__info-item">
            <div className="dashboard__info-item-hero">
              <h6>Unidentified Customers</h6>
              <p>{unindefiedCustomers}</p>
            </div>
            <div className="dashboard__info-item-icon">
              <Icon name="unidentified-customers" />
            </div>
          </div>
        </div>
        <div className="dashboard__info-row">
          <div className="dashboard__info-item">
            <div className="dashboard__info-item-hero">
              <h6>Male</h6>
              <p>{maleBuyers}</p>
            </div>
            <div className="dashboard__info-item-icon">
              <Icon name="male" />
            </div>
          </div>
          <div className="dashboard__info-item">
            <div className="dashboard__info-item-hero">
              <h6>Female</h6>
              <p>{femaleBuyers}</p>
            </div>
            <div className="dashboard__info-item-icon">
              <Icon name="female" />
            </div>
          </div>
          <div className="dashboard__info-item">
            <div className="dashboard__info-item-hero">
              <h6>Average Age</h6>
              <p>{Math.floor(averageAge)}</p>
            </div>
            <div className="dashboard__info-item-icon">
              <Icon name="average-age" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
